import React from "react";

const VisionMission = () => {
    return (
        <section className="vision-mission-section py-5 bg-white">
            <div className="container">
                <div className="row justify-content-center mb-5">
                    <div className="section-title text-center">
                        <h6 className="wow fadeInUp"><i className="fa-regular fa-arrow-left-long" />our Vision & Mission<i className="fa-regular fa-arrow-right-long" /></h6>
                        <h2 className="wow fadeInUp" data-wow-delay=".2s">Our Vision & Mission</h2>
                    </div>
                </div>
                <div className="row g-4 align-items-stretch">
                    <div className="col-md-6">
                        <div className="card h-100 border-0 shadow-sm bg-light">
                            <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#DF1119' }}>
                                    <i className="fas fa-eye"></i>
                                </div>
                                <h3 className="card-title mb-2" style={{ color: '#121315', fontWeight: '600' }}>Our Vision</h3>
                                <p className="mt-3 text-start">V-Make envisions becoming India's most trusted and forward-thinking brand in the WPC doors and frames industry. Our goal is to lead the market by consistently delivering products that combine cutting-edge innovation, long-lasting durability, and environmentally responsible materials. We aim to transform the way residential and commercial spaces are designed—offering sustainable, stylish, and maintenance-free solutions that cater to modern architectural needs while protecting the planet for future generations.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card h-100 border-0 shadow-sm bg-light">
                            <div className="card-body p-4 d-flex flex-column justify-content-center align-items-center text-center">
                                <div className="mb-3" style={{ fontSize: '2.5rem', color: '#DF1119' }}>
                                    <i className="fas fa-bullseye"></i>
                                </div>
                                <h3 className="card-title mb-2" style={{ color: '#121315', fontWeight: '600' }}>Our Mission</h3>
                                <p className="mt-3 text-start">At V-Make, our mission is to design and manufacture WPC doors and frames that blend style, strength, and sustainability. We deliver products that enhance spaces while providing superior performance. Through our focus on durability, eco-friendly materials, and zero-maintenance solutions, we serve homeowners, architects, and industry partners with trustworthy products they can confidently recommend.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VisionMission;